module.exports = __webpack_public_path__ + "img/title.9bf11b48.png";